import React from 'react';

function Admin() {
  return <div className="container mt-5"><h2>Admin Dashboard</h2></div>;
}

export default Admin;